var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CheckBox, InputContainer } from "@animech/ui";
import { t } from "i18next";
import { Unit } from "utility/number";
import { tubeDiameterOptions, TubeType } from "store/types";
import { useAppSelector, selectors } from "store";
import { StepperInput, StepperPlaceholder, } from "ui/components/elements/input/stepper-input";
import { NumberInput } from "ui/components/elements/input/number-input";
export var TubeSettings = function (_a) {
    var _b = _a.inputSize, inputSize = _b === void 0 ? "small" : _b, _c = _a.isBlowOffTube, isBlowOffTube = _c === void 0 ? false : _c, isUsingCustomValue = _a.isUsingCustomValue, value = _a.value, valueIndexes = _a.valueIndexes, onValueChange = _a.onValueChange, label = _a.label, tubeType = _a.tubeType;
    var unitSystem = useAppSelector(selectors.selectUnitSystem);
    var parsedValue = parseFloat(value) / 1000;
    var options = tubeDiameterOptions[unitSystem];
    var closestIndexToValue = options
        .map(function (o) { return Math.abs(o.value - parsedValue); })
        .indexOf(Math.min.apply(Math, __spreadArray([], __read(options.map(function (o) { return Math.abs(o.value - parsedValue); })), false)));
    return (_jsxs(_Fragment, { children: [isUsingCustomValue ? (_jsx(StepperPlaceholder, { value: t("sidebar.edit_tube.custom_tube_diameter"), label: label, size: inputSize })) : (_jsx(StepperInput, { isBlowOffTube: isBlowOffTube, label: label, diameterIndexes: valueIndexes, onValueChange: onValueChange, isTooltip: inputSize === "small", tubeType: tubeType })), !isBlowOffTube && tubeType === TubeType.VACUUM && (_jsx(CheckBox, { color: "inverted", value: isUsingCustomValue, label: t("sidebar.edit_tube.custom_tube_diameter_label"), onValueChange: function (useCustomDiameter) {
                    onValueChange(useCustomDiameter
                        ? parsedValue
                        : options[closestIndexToValue].value, useCustomDiameter ? undefined : closestIndexToValue);
                } })), isUsingCustomValue && (_jsx(InputContainer, { children: _jsx(NumberInput, { unit: Unit.MM, type: "float", value: value, setValue: function (newValue) { return onValueChange(parseFloat(newValue) / 1000); } }) }))] }));
};
